import qs from "qs";
import React from "react";

const KindTypeDesc: React.FC<any> = ({ kindData, adBanner }) => {
  const { kindType } = qs.parse(window.location.search, { ignoreQueryPrefix: true });
  return (
    <div id='KindTypeDesc' className='relative'>
      <div className={`flex items-center h-full`}>
        {!!kindData?.thumb && (
          <div className={`w-450 h-300 flex justify-center items-center `}>
            <img className='w-full' src={kindData?.thumb} />
          </div>
        )}
        {!kindData && (
          <div
            className={`w-450 h-300 flex justify-center items-center rounded-18 bg-[#FAFCFF] ${
              kindType === "tradeIn" ? "mt-0" : "mt-40"
            } `}
          >
            <img className='w-216 h-110' src='https://photo.8891.com.tw/2023/11/01/1698822038777006.png' />
          </div>
        )}

        {/* {!!adBanner && !!kindData?.thumb && (
          <div className={`w-450 flex justify-center items-center  ${kindType === "tradeIn" ? "-mt-10" : "mt-10"}`}>
            <img className='w-420 h-auto' src={adBanner} />
          </div>
        )} */}
      </div>
    </div>
  );
};
export default KindTypeDesc;
